import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function LockIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99887 10C6.99564 9.33021 6.99261 8.57227 7.09726 7.8581C7.22262 7.00264 7.51267 6.11434 8.20969 5.40009C8.98525 4.60536 10.1912 4 12 4C13.8088 4 15.0147 4.60536 15.7903 5.4001C16.4873 6.11434 16.7774 7.00264 16.9027 7.85809C17.0074 8.57227 17.0044 9.3302 17.0011 10H17.25C18.2165 10 19 10.7835 19 11.75V17.25C19 18.7688 17.7688 20 16.25 20H7.75C6.23122 20 5 18.7688 5 17.25V11.75C5 10.7835 5.78352 10 6.75 10H6.99887ZM9.28322 6.44772C9.75133 5.96804 10.5578 5.5 12 5.5C13.4422 5.5 14.2487 5.96804 14.7167 6.4477C15.1101 6.85081 15.3183 7.39131 15.4186 8.0756C15.5061 8.6725 15.5036 9.3061 15.5009 9.98472L15.5009 9.98576C15.5009 9.9905 15.5009 9.99525 15.5009 10H8.49913C8.49911 9.99491 8.49909 9.98983 8.49907 9.98474C8.49642 9.30615 8.49394 8.67246 8.58141 8.07559C8.68168 7.3913 8.88985 6.85081 9.28322 6.44772ZM6.5 11.75C6.5 11.6119 6.61192 11.5 6.75 11.5H17.25C17.3881 11.5 17.5 11.6119 17.5 11.75V17.25C17.5 17.9404 16.9404 18.5 16.25 18.5H7.75C7.05964 18.5 6.5 17.9404 6.5 17.25V11.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
